import { render, staticRenderFns } from "./timeline-card.vue?vue&type=template&id=38525df8"
import script from "./timeline-card.vue?vue&type=script&lang=js"
export * from "./timeline-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports